// extracted by mini-css-extract-plugin
export var settingsList = "_3h-0";
export var settingsRow = "_3h-1";
export var warningDot = "_3h-2";